export default __webpack_public_path__ + "static/media/sub_logo.79ecb22c.svg";